import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedBarrierCodes } from '@hooks/mocks/barrierCodes'
import { mockedBarriers } from '@hooks/mocks/barriers'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

import { IBarrier, IBarrierCode } from '../../interfaces/task/barrier'

export function useFindBarriers(taskId: number) {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchBarrier() {
    if (!isMockEnvironment) {
      const { data } = await api.get<IBarrier[]>(
        `sites/${siteId}/tasks/${taskId}/barriers`,
      )
      return data
    }

    return mockedBarriers
  }

  return useQuery({ queryFn: fetchBarrier, queryKey: ['BARRIERS', taskId] })
}

export function useFindBarriersCodes() {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchBarriersCodes() {
    if (!isMockEnvironment) {
      const { data } = await api.get<IBarrierCode[]>(
        `sites/${siteId}/barrierCodes`,
      )
      return data
    }
    return mockedBarrierCodes
  }

  return useQuery({ queryFn: fetchBarriersCodes, queryKey: ['BARRIER_CODES'] })
}
